import { TranslateFunc } from 'common/types';
import React, { MouseEvent, forwardRef, RefObject } from 'react';
import styled from 'styled-components';
import constants, { border } from '../common/theme/constants';
import KitLink from './KitLink';

const StyledNavSpan = styled.span<{ active: boolean }>`
  color: ${({ theme }) => theme.page.header.text};
  border-bottom: ${({ theme, active }) => (active ? `4px solid ${theme.link.active}` : '0')};
  font-weight: ${({ active }) =>
    active ? constants.fontWeight.bold : constants.fontWeight.normal};
`;

const StyledLink = styled(KitLink)`
  padding: ${constants.spacing.s}rem ${constants.spacing.m}rem;
  display: block;
  outline: none;
  &:focus {
    outline: none;
    box-shadow: inset 0 0 0 ${border.width}px ${({ theme }) => theme.focus};
  }
  &&:hover {
    text-decoration: none;
  }
`;

export interface KitNavLinkProps {
  useReactRouter?: boolean;
  name: string;
  isActive: boolean;
  path: string;
  tabIndex?: number;
  target?: string;
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
  t: TranslateFunc;
}

const KitNavLink = forwardRef((props: KitNavLinkProps, ref: RefObject<HTMLAnchorElement>) => {
  const { useReactRouter = true } = props;
  const navSpan = <StyledNavSpan active={props.isActive}>{props.name}</StyledNavSpan>;

  if (useReactRouter) {
    return (
      <StyledLink
        to={props.path}
        onClick={props.onClick}
        ref={ref}
        tabIndex={props.tabIndex}
        target={props.target}
        t={props.t}
      >
        {navSpan}
      </StyledLink>
    );
  }

  return (
    <StyledLink
      href={props.path}
      onClick={props.onClick}
      ref={ref}
      tabIndex={props.tabIndex}
      target={props.target}
      t={props.t}
    >
      {navSpan}
    </StyledLink>
  );
});

export default KitNavLink;
